/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import BestProductCard from "../ProductCardSlide";
import UseFetch from "../../hook/useFetch";
import "./style.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

export default function ProductBrand({ brand }) {
  const { data, loading } = UseFetch(
    "https://ebuy-backend-two.vercel.app/api/article"
  );

  const produits = useMemo(() => {
    return Array.isArray(data) ? [...data].reverse() : [];
  }, [data]);

  const [itemsPerPage, setItemsPerPage] = useState(6);
  const [currentCards, setCurrentCards] = useState([]);

  // ----------------------------
  // RESPONSIVE SLIDES
  // ----------------------------
  useEffect(() => {
    const updateItems = () => {
      const w = window.innerWidth;

      if (w >= 1800) setItemsPerPage(6);
      else if (w >= 1350) setItemsPerPage(5);
      else if (w >= 700) setItemsPerPage(4);
      else setItemsPerPage(2);
    };

    updateItems();
    window.addEventListener("resize", updateItems);

    return () => window.removeEventListener("resize", updateItems);
  }, []);

  // ----------------------------
  // FILTER PRODUCTS BY BRAND
  // ----------------------------
  useEffect(() => {
    if (!brand || !produits.length) return;

    const normalize = (str) =>
      str?.toString().trim().toLowerCase();

    const filtered = produits.filter(
      (p) => normalize(p.brand) === normalize(brand)
    );

    const shuffled = [...filtered].sort(() => Math.random() - 0.5);

    setCurrentCards(shuffled.slice(0, 12));
  }, [brand, produits]);

  // ----------------------------
  // ARROWS
  // ----------------------------
  const CustomPrevArrow = ({ onClick }) => (
    <div className="custom-arrow custom-prev" onClick={onClick}>
      <ArrowBackIosIcon />
    </div>
  );

  const CustomNextArrow = ({ onClick }) => (
    <div className="custom-arrow custom-next" onClick={onClick}>
      <ArrowForwardIosIcon />
    </div>
  );

  // ----------------------------
  // SAFE SLIDES
  // ----------------------------
  const safeSlides = Math.min(
    itemsPerPage,
    currentCards.length || 1
  );

  const settings = {
    dots: false,
    speed: 500,
    slidesToShow: safeSlides,
    slidesToScroll: 1,
    infinite: currentCards.length > safeSlides,
    adaptiveHeight: true,
    swipeToSlide: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };

  // ----------------------------
  // LOADING / EMPTY STATE
  // ----------------------------
  if (loading) {
    return (
      <div className="loaderContainer">
        <div className="loader"></div>
      </div>
    );
  }

  if (!currentCards.length) {
    return null;
  }

  // ----------------------------
  // RENDER
  // ----------------------------
  return (
    <Slider {...settings}>
      {currentCards.map((produit, index) => (
        <div
          key={(produit.articleName || index) + index}
          className="bestProduct"
        >
          <BestProductCard
            categorie={produit.categorie}
            subSubcategorie={produit.subSubcategorie}
            article={produit.article}
            prix={produit.prix}
            prixPromo={produit.prixPromo}
            prixFlash={produit.prixFlash}
            colors={produit.colors}
            brand={produit.brand}
            famille={produit.famille}
            subcategorie={produit.subcategorie}
            stock={produit.stock}
            livraisonGratuit={produit.livraisonGratuit}
            nouveau={produit.nouveau}
          />
        </div>
      ))}
    </Slider>
  );
}